import { useQuery } from '@apollo/client';
import { mapMoneyV2ToMoney } from '../../utils/money';
import { query } from './query';
import { Balances as Query } from './query.types';

export const useBalance = (currency: string) => {
  const { data, loading, error } = useQuery<Query>(query);
  const result = data?.currentUser?.balances?.find(
    ({ amount }) => amount?.currency.code === currency
  );

  return {
    loading,
    error,
    balance: mapMoneyV2ToMoney(result?.amount),
  };
};
